import { Injectable } from '@angular/core';

import { EntityListPayloadModel } from 'src/app/model';
import { ServicecallService } from 'src/app/services/servicecall.service'; 
import { MonotainerDetails } from '../components/3dPlanogram/inputGroup';
@Injectable({
  providedIn: 'root'
})
export class InputFetchService {
  constructor(
    private _sharedService:ServicecallService
  ) {}
  _availableMonotainers: any = [];
  _dataToSend:MonotainerDetails[]=[];

  /**
   * Gets available monotianers from api response
   * and creates monotainers in sort area
   * @returns available monotianers 
   */
  getAvailableMonotianers(): Promise<MonotainerDetails[]> {
    return new Promise<MonotainerDetails[]>((resolve) => {
      const payloadContent: Partial<EntityListPayloadModel> = {
        status: true,
        siteId: this._sharedService.getSiteId(),
        type: 2,
        category: this._sharedService.getConfiguration('tenantCategory') ? this._sharedService.getConfiguration('tenantCategory').tenantCategory?.category : null,
      };
      this._sharedService.entitiesList(payloadContent, null).subscribe((result: any) => {
        if (result['status']) {
          this._availableMonotainers = result['response']['data']?.[0]?.['data'];
          this._dataToSend = this._availableMonotainers.map((element: { name: string; }) => ({
            name: element.name
          }));
          resolve(this._dataToSend); // Resolve the promise with the data
        }
      });
    });
  }
}
